export const Api_url = `/api`;

//LOGIN
export const POST_PARENTLOGIN = `${Api_url}/auth/parent/login`;
export const POST_USERLOGIN = `${Api_url}/auth/user/login`;
export const SOCIAL_LOGIN = "/social-login";
export const USER_LOGOUT = `${Api_url}/auth/user/logout`;

export const PARENT_LOGOUT = `${Api_url}/auth/parent/logout`;
//logoutLogdetails
// export const POST_USERLOGOUT_LOGS = `${Api_url}/auth/user/logout`

//newforgototp
export const FORGOTVERIFY = `${Api_url}/auth/forgotverify`;
export const FORGOT_PASSWORD = `${Api_url}/users/forgot-password`;
export const RESET_PASSWORD = `${Api_url}/users/reset-password`;
export const VERIFY_TOKEN = `${Api_url}/auth/verifyJwtToken`;
export const CLEAR_TOKEN = `${Api_url}/auth/clearToken`;
export const CHANGE_PASSWORD = `${Api_url}/users/change-password`;
export const PARENT_CHANGE_PASSWORD = `${Api_url}/parent/change-password`;

export const PARENT_FORGOT_PASSWORD = `${Api_url}/parent/parent-forgot-password`;
export const PARENT_RESET_PASSWORD = `${Api_url}/parent/parent-reset-password`;

// user
export const GET_USERS_BY_ID = `${Api_url}/users/get-user-by-id`;
export const UPDATE_USERS_BY_ID = `${Api_url}/users/update-user`;
export const SEND_USER_RESET_PASSWORD = `${Api_url}/users/bulk-reset-password`;


// parent
export const CREATE_PARENT = `${Api_url}/parent/create`;
export const GET_PARENT_BY_ID = `${Api_url}/parent/get-by-id`;
export const UPDATE_PARENT_BY_ID = `${Api_url}/parent/update`;
export const UPDATE_PARENT_STATUS = `${Api_url}/parent/update-status`;
export const GET_ALL_PARENTS = `${Api_url}/parent/get-all`;
export const UPDATE_ALL_PASSWORD = `${Api_url}/parent/update-all-password`;
export const DELETE_PARENT_BY_ID = `${Api_url}/parent/update-deleted`;
export const DELETE_MULTIPLE_PARENT_BY_ID = `${Api_url}/parent/update-multi-deleted`;
export const SEND_RESET_PASSWORD = `${Api_url}/parent/bulk-reset-password`;
export const GET_ALL_PARENTS_NAME = `${Api_url}/parent/get-all-parents-name`;
export const UPDATE_LATE_FEE = `${Api_url}/student-fb/update-is-late-fee`;
export const UPDATE_TERM_LATE_FEE = `${Api_url}/student-fb/update-term-permission`;
export const GET_ALL_PARENTS_PAGINATION = `${Api_url}/parent/get-all-parents`;
export const UPDATE_STUDENT_FLAGS = `${Api_url}/student-fb/update-student-flags`;


//Talc Centre
export const CREATE_CENTRE = `${Api_url}/center/create`;
export const GET_ALL_CENTRE = `${Api_url}/center/get-all`;
export const GET_CENTRE_BY_ID = `${Api_url}/center/get`;
export const UPDATE_CENTRE_BY_ID = `${Api_url}/center/update`;
export const DELETE_CENTRE_BY_ID = `${Api_url}/center/delete`;

// program type
export const CREATE_PROGRAM_TYPE = `${Api_url}/program-type/create`;
export const GET_ALL_PROGRAM_TYPE = `${Api_url}/program-type/get-all`;
export const GET_PROGRAM_TYPE_BY_ID = `${Api_url}/program-type/get`;
export const UPDATE_PROGRAM_TYPE_BY_ID = `${Api_url}/program-type/update`;
export const DELETE_PROGRAM_TYPE_BY_ID = `${Api_url}/program-type/delete`;
export const CHANGE_STUDENT_PROGRAM = `${Api_url}/student-program`;
export const GET_OLD_PROGRAM_FEES = `${Api_url}/student-program`;

// student
export const CREATE_STUDENT = `${Api_url}/student-fb/create`;
export const GET_ALL_STUDENT_DATA = `${Api_url}/student-fb/get-all`;
export const GET_ALL_STUDENT_DATA_WITH_PAGINATION = `${Api_url}/student-fb/get-all-students`;
export const GET_STUDENT_DATA_BY_ID = `${Api_url}/student-fb/get`;
export const GET_STUDENT_BY_PRIMARYEMAILID = `${Api_url}/student-fb/students-by-parent`;
export const UPDATE_STUDENT = `${Api_url}/student-fb/update`;
export const GET_FEES_BY_PROGRAM_TYPE = `${Api_url}/student-fb/get-fees`;
export const GET_FEES_PAID_BY_STATUS_CODE = `${Api_url}/fees-paid/get-by-student`;

export const GET_FEES_PAID_BY_STATUS_CODE_FOR_OTHER_CHARGE = `${Api_url}/fees-paid/get-by-student-othercharge`;

export const GET_ALL_STUDENT_DATA_BY_MENTORID = `${Api_url}/student-fb/get-by-mentor-center`;
export const DELETE_Student_BY_ID = `${Api_url}/student-fb/update-deleted`;
export const STUDENT_BY_CENTER_ID = `${Api_url}/student-fb/student/center`;
export const UPDATE_OBSERVATION_BY_EXISTING_PARENT = `${Api_url}/student-fb/update-existing-observation`;
export const DELETE_MULTIPLE_STUDENT_BY_ID = `${Api_url}/student-fb/update-multi-deleted`;
export const GET_ALL_STUDENTS_TERM_CONFIGS = `${Api_url}/student/term-configs`;
export const UPSERT_STUDENT_TERM_CONFIGS = `${Api_url}/student`;
export const DISCONTINUE_STUDENT = `${Api_url}/student-fb/discontinue`;
export const REJOIN_STUDENT = `${Api_url}/student-fb/rejoin`;
export const GET_DISCONTINUE_HISTORY = `${Api_url}/student-fb/discontinue-history`;

// getcount from student admin
export const GET_COUNT_BY_CATEGORY = `${Api_url}/student-fb/count/category`;
export const GET_COUNT_BY_CENTER = `${Api_url}/student-fb/count/center`;
export const GET_COUNT_BY_CLUSTER = `${Api_url}/student-fb/count/cluster`;
export const GET_COUNT_BY_PROGRAM_TYPE = `${Api_url}/student-fb/count/program`;
export const GET_COUNT_BY_STUDENT = `${Api_url}/student-fb/count/student`;
export const GET_COUNT_BY_SPLIT_PAYMENT = `${Api_url}/student-fb/count/split`;
export const GET_ACTIVE_STUDENT_COUNT = `${Api_url}/student-fb/active-count`;
export const GET_INACTIVE_STUDENT_COUNT = `${Api_url}/student-fb/inactive-count`;
export const GET_COUNT_BY_PAYMENT = `${Api_url}/student-fb/count/payment`;

export const GET_FULL_PAID_COUNT = `${Api_url}/fees-paid/overall-full-paid-fees`;
export const GET_FULL_UNPAID_COUNT = `${Api_url}/fees-paid/overall-full-unpaid-fees`;
export const GET_INSTALLMENT_COUNT_PAID = `${Api_url}/fees-paid/overall-installment-paid-fees`;
export const GET_INSTALLMENT_COUNT_UNPAID = `${Api_url}/fees-paid/overall-installment-unpaid-fees`;
export const GET_FULL_TERM_PAID_UNPAID_COUNT = `${Api_url}/fees-paid/full-term-status`;

export const BULK_ALLOCATE_RE_REGISTRATION_TYPE = `${Api_url}/late-fees/bulk-update-re-registration`;

//SMTP Email
export const GET_SMTP_DETAIL = `${Api_url}/users/smtp-details`;
export const UPDATE_SMTP_DETAIL = `${Api_url}/users/update-smtp-details`;

//Event Cluster url_helper
export const CREATE_CLUSTER = `${Api_url}/cluster/create`;
export const GET_ALL_CLUSTER = `${Api_url}/cluster/get-all`;
export const GET_CLUSTER_BY_ID = `${Api_url}/cluster/get`;
export const UPDATE_CLUSTER = `${Api_url}/cluster/update`;
export const DELETE_CLUSTER_BY_ID = `${Api_url}/cluster/delete`;

// discount
export const CREATE_DISCOUNT = `${Api_url}/discount/create`;
export const GET_ALL_DISCOUNT = `${Api_url}/discount/get-all`;
export const GET_DISCOUNT_BY_ID = `${Api_url}/discount/get-by-id`;
export const UPDATE_DISCOUNT_BY_ID = `${Api_url}/discount/update`;
export const DELETE_DISCOUNT_BY_ID = `${Api_url}/discount/delete`;
export const GET_DISCOUNT_STUDENTS = `${Api_url}/discount/get-student-id`;
export const BULK_ALLOCATE_DISCOUNT = `${Api_url}/discount/bulk-update-discount`;
export const BULK_UN_ALLOCATE_DISCOUNT = `${Api_url}/discount/bulk-update-discount-unallocate`;
export const GET_ALL_STUDENT_DISCOUNT = `${Api_url}/discount/students-discounts`;
export const GET_ONLY_STUDENT_DISCOUNT = `${Api_url}/discount/discounts-with-students`;
export const GET_STUDENT_DISCOUNT_UNALLOCATION_HISTORY = `${Api_url}/discount/student-discount-unallocation-history`;

// Category
export const CREATE_CATEGORY = `${Api_url}/category/create`;
export const GET_ALL_CATEGORY = `${Api_url}/category/get-all`;
export const GET_CATEGORY_BY_ID = `${Api_url}/category/get`;
export const UPDATE_CATEGORY = `${Api_url}/category/update`;
export const DELETE_CATEGORY_BY_ID = `${Api_url}/category/delete`;

//Fees Structure
export const CREATE_FEES_STUCTURE = `${Api_url}/fees-structure/create`;
export const GET_ALL_FEES_STUCTURE = `${Api_url}/fees-structure/get-all`;
export const GET_FEES_STUCTURE_BY_ID = `${Api_url}/fees-structure/get-by-id`;
export const UPDATE_FEES_STUCTURE_BY_ID = `${Api_url}/fees-structure/update`;
export const GET_FEES_STURCTURE_BY_STUDENT_ID = `${Api_url}/fees-structure/get`;
export const DELETE_FEES_STUCTURE_BY_ID = `${Api_url}/fees-structure/delete`;
export const GET_FEES_STRUCTURE_BY_PROGRAM_CENTER_ACADEMIC = `${Api_url}/fees-structure/get`;

//roles
export const GET_ROLES_BY_ID = `${Api_url}/roles/get`;
export const UPDATE_ROLES_BY_ID = `${Api_url}/roles/update`;
export const GET_ALL_ROLES = `${Api_url}/roles/get-all`;

// Academic Year
export const CREATE_ACADEMIC = `${Api_url}/acadamic/create`;
export const GET_ALL_ACADEMIC = `${Api_url}/acadamic/get-all`;
export const GET_ACADEMIC_BY_ID = `${Api_url}/acadamic/get`;
export const UPDATE_ACADEMIC_YEAR = `${Api_url}/acadamic/update`;
export const DELETE_ACADEMIC_BY_ID = `${Api_url}/acadamic/delete`;
export const GET_ALL_MASETER_DATA = `${Api_url}/master/get-all-master-data`;

// fee-Structure
export const GET_ALL_FEE_TERM = `${Api_url}/fees-structure/get-fee-terms`;

// fee-terms
export const GET_FEE_TERMS_FOR_STUDENT = `${Api_url}/fee-term/get-fee-terms`;

// payment
export const CREATE_PAYMENT = `${Api_url}/payment-type/create`;
export const GET_ALL_PAYMENT = `${Api_url}/payment-type/get-all`;
export const GET_PAYMENT_BY_ID = `${Api_url}/payment-type/get`;
export const UPDATE_PAYMENT_BY_ID = `${Api_url}/payment-type/update`;
export const DELETE_PAYMENT_BY_ID = `${Api_url}/payment-type/delete`;

// bulk allocate
export const BULK_ALLOCATE_PAYMENT = `${Api_url}/student-fb/bulk-update-payment-type`;

// users
export const CREATE_USER = `${Api_url}/users/create`;
export const CREATE_USER_WITH_MAPPING = `${Api_url}/users/create-with-mapping`;
export const GET_ALL_USER = `${Api_url}/users/get-all-users`;
export const GET_USER_BY_ID = `${Api_url}/users/get-user-by-id`;
export const UPDATE_USER_BY_ID = `${Api_url}/users/update-user`;

// Support Staff
export const CREATE_SUPPORT_STAFF = `${Api_url}/users/support-staff/create`;
export const GET_ALL_SUPPORT_STAFF = `${Api_url}/users/support-staff/get-all`;
export const GET_SUPPORT_STAFF_BY_ID = `${Api_url}/users/support-staff/get`;
export const UPDATE_SUPPORT_STAFF = `${Api_url}/users/support-staff/update`;
export const DELETE_USER_BY_ID = `${Api_url}/users/delete`;

// user mapping
export const CREATE_USER_MAPPING = `${Api_url}/user-map/create`;
export const GET_ALL_USER_MAPPING = `${Api_url}/user-map/get-all`;
export const GET_USER_BY_ID_MAPPING = `${Api_url}/user-map/get-by-id`;
export const UPDATE_USER_BY_ID_MAPPING = `${Api_url}/user-map/update`;
export const DELETE_USER_BY_ID_MAPPING = `${Api_url}/user-map/delete`;

// fee-paid
export const CREATE_FEES_PAID = `${Api_url}/fees-paid/create`;
export const CREATE_FEES_PAID_ADMIN = `${Api_url}/fees-paid/create-admin-fee`;
export const REFUND_FEES_PAID = `${Api_url}/fees-paid/refund-fee`;
export const GET_ALL_FEES_PAID = `${Api_url}/fees-paid/get-all`;
export const GET_DISCOUNT_BY_STUDENT_ID = `${Api_url}/discount/get-by-student_id`;
export const GET_TODAY_FEES = `${Api_url}/fees-paid/today`;
export const GET_THIS_WEEK_FEES = `${Api_url}/fees-paid/this-week`;
export const GET_THIS_MONTH_FEES = `${Api_url}/fees-paid/this-month`;
export const GET_THIS_YEAR_FEES = `${Api_url}/fees-paid/this-year`;
export const UPDATE_FEES_PAID = `${Api_url}/fees-paid/update`;
export const UPDATE_FEES_PAID_ORDER_ID = `${Api_url}/fees-paid/update-by-order-id`;
export const CREATE_PAYMENT_TYPE_2_FEE_LOGIC = `${Api_url}/fees-paid/create-fees-2`;

export const GET_ALL_FEES_PAID_DETAILS = `${Api_url}/fees-paid/get-all-paid-details`;
export const GET_ADMIN_FEES_PAID_DETAILS = `${Api_url}/fees-paid/get-admin-paid-details`;

export const GET_FEES_PAID_BY_ID = `${Api_url}/fees-paid/get-by-id`;

// centerprogrammapping
export const CREATE_CENTER_PROGRAM_MAPPING = `${Api_url}/center-program//mutliple-create`;
export const GET_ALL_CENTER_PROGRAM_MAPPING = `${Api_url}/center-program/get-all`;
export const GET_CENTER_PROGRAM_MAPPING_BY_CENTER_ID = `${Api_url}/center-program/get-by-center`;
export const UPDATE_CENTER_PROGRAM_MAPPING = `${Api_url}/center-program/update`;
// export const DELETE_CENTER_PROGRAM_MAPPING = `${Api_url}/center-program/delete`;

// centercategorymapping
export const CREATE_CENTER_CATEGORY_MAPPING = `${Api_url}/center-category/mutliple-create`;
export const GET_ALL_CENTER_CATEGORY_MAPPING = `${Api_url}/center-category/get-all`;
export const GET_CENTER_CATEGORY_MAPPING_BY_CENTER_ID = `${Api_url}/center-category/get-by-center`;
export const UPDATE_CENTER_CATEGORY_MAPPING = `${Api_url}/center-category/update`;
// export const DELETE_CENTER_CATEGORY_MAPPING = `${Api_url}/center-category/delete`;

// centerclustermapping
export const CREATE_CENTER_CLUSTER_MAPPING = `${Api_url}/center-cluster/mutliple-create`;
export const GET_ALL_CENTER_CLUSTER_MAPPING = `${Api_url}/center-cluster/get-all`;
export const GET_CENTER_CLUSTER_MAPPING_BY_CENTER_ID = `${Api_url}/center-cluster/get-by-center`;
export const UPDATE_CENTER_CLUSTER_MAPPING = `${Api_url}/center-cluster/update`;
// export const DELETE_CENTER_CLUSTER_MAPPING = `${Api_url}/center-cluster/delete`;

// center-based display cluster, program type, category
export const GET_CLUSTER_PROGRAM_CATEGORY_BY_CENTER = `${Api_url}/center/details`;

// installment count
export const GET_INSTALLMENT_COUNT_PAID_AND_UNPAID = `${Api_url}/fees-paid/get-instalment-fee-details`;

// center head counts
export const CENTER_HEAD_COUNT_BY_CATEGORY = `${Api_url}/student-fb/count/category`;
export const CENTER_HEAD_COUNT_BY_CENTER = `${Api_url}/student-fb/count/center`;
export const CENTER_HEAD_COUNT_BY_CLUSTER = `${Api_url}/student-fb/count/cluster`;
export const CENTER_HEAD_COUNT_BY_PROGRAM_TYPE = `${Api_url}/student-fb/count/program`;
export const CENTER_HEAD_COUNT_BY_STUDENT = `${Api_url}/student-fb/count/student`;
export const CENTER_HEAD_COUNT_BY_SPLIT_PAYMENT = `${Api_url}/student-fb/count/split`;
export const CENTER_HEAD_COUNT_BY_PAYMENT = `${Api_url}/student-fb/count/payment`;
export const CENTER_HEAD_ACTIVE_STUDENT_COUNT = `${Api_url}/student-fb/count/active`;
export const CENTER_HEAD_INACTIVE_STUDENT_COUNT = `${Api_url}/student-fb/count/inactive`;
export const CENTER_HEAD_FULL_PAID_FEES = `${Api_url}/fees-paid/get-full-paid-unpaid-centerhead`;
export const CENTER_HEAD_FULL_UNPAID_FEES = `${Api_url}/fees-paid/get-overall-full-unpaid-fees-centerhead`;
export const CENTER_HEAD_TERM_PAID_FEES = `${Api_url}/fees-paid/get-overall-term-paid-fees-centerhead`;
export const CENTER_HEAD_TERM_UNPAID_FEES = `${Api_url}/fees-paid/get-terms-paid-unpaid-centerhead`;
export const CENTER_HEAD_COUNT_BY_CATEGORY_PROGRAM_CLUSTER = `${Api_url}/student-fb/get-student-count-by-centerhead`;

//ccaveneue
export const POST_CCAVENUE_ORDER = `${Api_url}/ccavenue/response`;
export const GET_CCAVENUE_ORDER = `${Api_url}/ccavenue/ccavRequestHandler`;

// fee-type
export const CREATE_FEE_TYPE = `${Api_url}/fees-type/create`;
export const GET_ALL_FEE_TYPE = `${Api_url}/fees-type/get-all`;
export const GET_FEE_TYPE_ID = `${Api_url}/fees-type/get-by-id`;
export const UPDATE_FEE_TYPE_ID = `${Api_url}/fees-type/update`;
export const DELETE_FEE_TYPE_ID = `${Api_url}/fees-type/delete`;
export const BULK_ALLOCATE_FEE_TYPE = `${Api_url}/fees-type/bulk-update-feestype`;
export const CC_AVENUE = `${Api_url}/ccavenue/response`;
export const BULK_UNALLOCATE_FEE_TYPE = `${Api_url}/fees-type/bulk-update-feestype-unallocate`;

// notifiction
export const GET_ALL_NOTIFICATION = `${Api_url}/notification/get-all`;
export const CREATE_NOTIFICATION = `${Api_url}/notification/create`;
export const UPDATE_NOTIFICATION = `${Api_url}/notification/update`;

// reminder
export const CREATE_REMINDER = `${Api_url}/reminder/create`;
export const GET_REMINDER = `${Api_url}/reminder/get`;
export const UPDATE_REMINDER = `${Api_url}/reminder/update`;
export const DELETE_REMINDER = `${Api_url}/reminder/delete`;

// backaccount-details
export const CREATE_BANK_ACCOUNT = `${Api_url}/bank-account/create`;
export const GET_ALL_BANK_ACCOUNTS = `${Api_url}/bank-account/get-all`;
export const GET_BANK_ACCOUNT_BY_ID = `${Api_url}/bank-account/get-by-id`;
export const UPDATE_BANK_ACCOUNT_BY_ID = `${Api_url}/bank-account/update`;
export const DELETE_BANK_ACCOUNT_BY_ID = `${Api_url}/bank-account/delete`;

// student Registration  and observation
export const CREATE_STUDENT_REGISTRATION = `${Api_url}/student-observation/create`;
export const GET_ALL_STUDENT_REGISTRATIONS = `${Api_url}/student-observation/get-all`;
export const GET_STUDENT_REGISTRATION_BY_ID = `${Api_url}/student-observation/get-by-id`;
export const GET_STUDENT_REGISTRATION_RECORD_BY_ID = `${Api_url}/student-observation/by-id`;
export const UPDATE_STUDENT_REGISTRATION_BY_ID = `${Api_url}/student-observation/update`;
export const DELETE_STUDENT_REGISTRATION_BY_ID = `${Api_url}/student-observation/update-deleted-status`;
export const CREATE_PARENT_REGISTRATION = `${Api_url}/student-observation/created-by-admin`;
export const UPDATE_STUDENT_REGISTRATION_OBSERVATION_ID = `${Api_url}/student-observation/update-by-id`;
export const GET_ALL_STUDENT_OBSERVATION_DETAILS = `${Api_url}/student-observation/student-observations-details`;
export const DELETE_STUDENT_OBSERVATION = `${Api_url}/student-observation/update-observation-delete-status`;
export const UPDATE_STUDENT_OBSERVATION_STATUS = `${Api_url}/student-observation/update-observation-status`;
export const UPDATE_STUDENT_ADMISSION_REASON = `${Api_url}/student-observation/admission-reason`;

export const ADMIT_STUDENT = `${Api_url}/student-observation/update-is-admit`;
export const REGENERATE_OBSERVATION_TOKEN = `${Api_url}/student-observation/regenerate-token`;
export const SEND_APPLICATION_FORM_TO_PARENT = `${Api_url}/student-observation/send-application`;
export const SEND_MULTIPLE_APPLICATION_FORM_TO_PARENT = `${Api_url}/student-observation/multiple-send-application`;

//ccavenue Registration
export const POST_CCAVENUE_ORDER2 = `${Api_url}/ccavenue/responses`;
export const GET_CCAVENUE_ORDER2 = `${Api_url}/ccavenue/ccavRequest-handler`;
export const GET_CCAVENUE_ORDER3 = `${Api_url}/ccavenue/ccavRequest-handler2`;
export const POST_CCAVENUE_ORDER3 = `${Api_url}/ccavenue/responses2`;


// existingRegisterForm
export const UPDATE_STUDENT_BASIC_INFO = `${Api_url}/existing-register-form/update/step1`;
export const UPDATE_EDUCATIONAL_VIEWS = `${Api_url}/existing-register-form/update/step2`;
export const UPDATE_PREFERENCES_AND_CONSENT = `${Api_url}/existing-register-form/update/step3`;
export const UPDATE_HEALTH_AND_BEHAVIORAL_INFO = `${Api_url}/existing-register-form/update/step4`;
export const UPDATE_SCHOOLING_AND_BEHAVIORAL_DETAILS = `${Api_url}/existing-register-form/update/step5`;
export const UPLOAD_PHOTO_EXITING_CHILD = `${Api_url}/existing-register-form/upload-child-photo`;
export const UPLOAD_DIAGNOSIS_DOCUMENT_EXITING_CHILD = `${Api_url}/existing-register-form/upload-diagnosis-attachments`;
export const UPLOAD_ASSESSMENT_DOCUMENT_EXITING_CHILD = `${Api_url}/existing-register-form/upload-reports-assessments`;

// newRegisterForm
export const UPDATE_NEW_STUDENT_BASIC_INFO = `${Api_url}/new-register-form/update/step1`;
export const UPDATE_NEW_EDUCATIONAL_VIEWS = `${Api_url}/new-register-form/update/step2`;
export const UPDATE_NEW_PREFERENCES_AND_CONSENT = `${Api_url}/new-register-form/update/step3`;
export const UPDATE_NEW_HEALTH_AND_BEHAVIORAL_INFO = `${Api_url}/new-register-form/update/step4`;
export const UPDATE_NEW_SCHOOLING_AND_BEHAVIORAL_DETAILS_FOR_PRE_PRIMARY = `${Api_url}/new-register-form/update/primary/step5`;
export const UPDATE_NEW_SCHOOLING_AND_BEHAVIORAL_DETAILS = `${Api_url}/new-register-form/update/step5`;
export const UPDATE_NEW_STUDENT_PAYMENT_PROCRESS = `${Api_url}/new-register-form/update/step6`;
export const UPLOAD_NEW_PHOTO_EXITING_CHILD = `${Api_url}/new-register-form/upload-child-photo`;
export const UPLOAD_NEW_DIAGNOSIS_DOCUMENT_EXITING_CHILD = `${Api_url}/new-register-form/upload-diagnosis-attachments`;
export const UPLOAD_NEW_ASSESSMENT_DOCUMENT_EXITING_CHILD = `${Api_url}/new-register-form/upload-reports-assessments`;
export const UPLOAD_OBSERVATION_REPORT = `${Api_url}/student-observation/observation-report`;
export const SEND_OBSERVATION_TO_PARENT = `${Api_url}/student-observation/send-observation-report`;


//register fee paid
export const GET_ALL_REGISTERATION_FEES_PAID = `${Api_url}/fees-paid/get-registeration-fee-details`;
export const GET_REGISTERATION_FEES_PAID_BY_ID = `${Api_url}/fees-paid/register-fee`;
export const GET_OBSERATION_AND_REGISTERATION_FEES_PAID_BY_ID = `${Api_url}/fees-paid/observation-registration-fee`;

//late fee
export const GET_ALL_LATE_FEES = `${Api_url}/late-fees/get-all`;

// get-all-student-fees-paid-details
export const GET_ALL_STUDENT_FEES_PAID_DETAILS = `${Api_url}/student-fb/get-all-fees-details`;

export const POST_CCAVENUE_ORDER_TYPE_2 = `${Api_url}/ccavenue-mom/responseType-2`;
export const GET_CCAVENUE_ORDER_TYPE_2 = `${Api_url}/ccavenue-mom/ccavRequestHandlerType-2`;
export const CREATE_PAYMENT_FEES_OTHER_FEES = `${Api_url}/fees-paid/create-fees`;

//other_fees
export const GENERATE_DUE_DATE = `${Api_url}/other_fees/generate-due-dates`;
export const OTHER_DETAILS_PAY_DETAILS = `${Api_url}/fees-type/get-student-by-fees-id`;
export const ALLOCATED_OTHER_FEES_STUDENTS = `${Api_url}/student-fb/get-all-other-fees-details`;
export const DUE_DATE_UPDATE = `${Api_url}/fees-type-student/update-due-date`;
export const GET_FEES_TYPE_STUDENT = `${Api_url}/fees-type-student/get`;
export const CANCEL_FEE_TYPE_STUDENT = `${Api_url}/fees-type-student`;
export const FEES_DETAILS_PAY_DETAILS = `${Api_url}/fees-paid/get-by-order-id`;


//pagination
export const GET_ALL_FEES_PAID_PAGINATION = `${Api_url}/pagination/fees-paid`;
export const GET_PROCESSING_FEES_PAGINATION = `${Api_url}/pagination/processing-fees`;
export const SOFT_DELETE_PROCESSING_FEES = `${Api_url}/pagination/processing-fees/delete`;
export const GET_ALL_ADMIN_FEES_PAID_PAGINATION = `${Api_url}/pagination/admin-fees-paid`;
export const GET_ALL_STUDENT_REGISTRATIONS_PAGINATION = `${Api_url}/student-observation/get-all-students-registration`;
export const GET_ALL_STUDENT_OBSERVATION_DETAILS_PAGINATION = `${Api_url}/student-observation/get-all-students-observations`;
export const GET_ALL_STUDENT_WITH_FEES_PAGINATION = `${Api_url}/pagination/students-with-fees`;
export const GET_PAGE_STUDENT_FEES_PAID_DETAILS = `${Api_url}/pagination/payment-status`;
export const FEES_SUMMARY = `${Api_url}/dashboard/fees-summary`;

export const GET_FEES_OVER_DUE_SUMMARY = `${Api_url}/dashboard/overdue-summary`;

export const GET_FEES_OVER_DUE_DETAILS = `${Api_url}/dashboard/overdue-details`;
export const GET_TUITION_FEES__DETAILS = `${Api_url}/dashboard/tuition-fees-summary`;
export const GET_FEES_STUDENT_DETAILS = `${Api_url}/dashboard/fees-student-details`;
export const GET_BIRTHDAYS = `${Api_url}/dashboard/get-birth-day`;
export const GET_ALLOCATED_OTHER_FEES = `${Api_url}/fees-type/get-allocated-fees`;
export const APP_VERSION = `${Api_url}/version`;
export const REGENERATE_REG_TOKEN = `${Api_url}/student-observation/re-registration`;
export const GET_ALL_AGE_GROUPS = `${Api_url}/age-group/get-all`;

// Parent Meetings
export const CREATE_PARENT_MEETING = `${Api_url}/meetings/parent-meetings`;
// GET /meetings/parent-meetings/my/:student_id — meetings for logged-in parent by student
export const GET_MY_PARENT_MEETINGS = `${Api_url}/meetings/parent-meetings/my`;
export const GET_PARENT_MEETING_BY_ID = `${Api_url}/meetings/parent-meetings`;
// GET /meetings/parent-meetings/get-students/:parent_id — student switcher dropdown
export const GET_PARENT_MEETING_STUDENTS = `${Api_url}/meetings/parent-meetings/get-students`;
// PUT /meetings/parent-meeting-requests/:id — updates a PENDING_APPROVAL request (row id, NOT meeting_id)
export const UPDATE_PARENT_MEETING = `${Api_url}/meetings/parent-meeting-requests`;

// Reschedule Requests
export const CREATE_RESCHEDULE_REQUEST = `${Api_url}/meetings`;
export const GET_RESCHEDULE_REQUESTS = `${Api_url}/meetings`;
export const GET_RESCHEDULE_REQUEST_BY_ID = `${Api_url}/meetings`;
// GET /meetings/by-participant/:parentId/reschedule-requests/:student_id (0 = all students)
export const GET_RESCHEDULE_REQUESTS_BY_PARTICIPANT = `${Api_url}/meetings/by-participant`;

export const getAllAgeGroups = () => get(url.GET_ALL_AGE_GROUPS);


// Parent Meetings & Operational Dashboard
export const GET_MY_MEETINGS = `${Api_url}/meetings/parent-meetings/my`;
export const GET_OPERATIONAL_DATES = `${Api_url}/meetings/operational-dates`;

// GET /meetings/parent-meetings/all/:parent_id/:student_id — ALL meetings mapped to parent + student
export const GET_ALL_PARENT_MEETINGS = `${Api_url}/meetings/parent-meetings/all`;